import { PagedSearch } from 'src/app/shared';

export class BannerSearchDto extends PagedSearch {
  IncludeInactive: boolean;
  AdKeyword: string;
  BannerName: string;
  CategoryID: number;
  StandardCategoryID: number;
  URL: string;
  ProfileName: string;
  SearchStartDate: Date;
  SearchEndDate: Date;

  public constructor() {
    super();
    this.SearchStartDate = new Date();
    this.SearchEndDate = new Date();
    //this.IncludeInactive = true;
  }
}
